import axios from "axios";
import { variables } from "../Variables.json";
import servicesApi from "../seller-apis/servicesApi";

const allowedVideoExtensions = [".mp4", ".mov"];

export const uploadVideo = async (file, vendorId = null) => {
  try {
    const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
    if (!allowedVideoExtensions.includes(fileExtension)) {
      throw new Error("Only MP4 and MOV videos are allowed.");
    }
    if (file.size > variables.limit.SellerSupport.video) {
      throw new Error("A max size of 15 MB video can be uploaded");
    }

    const str = file.name;
    const sanitizedName = str.replace(/[^\w]/g, "");
    const videoFinalName = `vid_${vendorId}_${sanitizedName}${fileExtension}`;

    const data = {
      mediaType: "video"
    };

    const formdata = new FormData();
    formdata.append("file", file);

    const res = await servicesApi.getUploadUrl(data);

    // Upload the file to the URL
    const uploadRes = await axios({
      method: "post",
      url: res.data,
      data: formdata,
      onUploadProgress: (data) => {
        //  handle progress here
      },
    });
    const videoKey = res.data.split('/').pop();

    return {
      msg: "success",
      url: videoKey,
      fileType: "video",
    };

  } catch (error) {
    console.error("Video upload error:", error.message || error);
    throw new Error(error.message || "Video Upload Failed");
  }
};